/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';
import CallToActionBlock from '../CallToActionBlock';
import { UPGRADE_TO_GET_BETTER_SUPPORT_CTA_HEADER } from '@zapier/product-get-help/src/constants';

type UpgradeProps = {
  /** Called when the user clicks the "Upgrade" button. */
  onClickUpgrade?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /** Called when the user presses a key while the upgrade button is focused. */
  onKeyDownUpgrade?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
  /** Called when the user clicks the "Learn more" link. */
  onClickLearnMore?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /** Called when the user presses a key while the learn more link is focused. */
  onKeyDownLearnMore?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
};

/**
  This CTA is displayed when the user is logged into a free plan
*/

const UpgradeBlock = ({
  onClickUpgrade,
  onKeyDownUpgrade,
  onClickLearnMore,
  onKeyDownLearnMore,
}: UpgradeProps) => (
  <CallToActionBlock
    backgroundColor="neutral100"
    bottomLinkText="Learn more about paid support"
    bottomLinkUrl="https://zapier.com/l/support"
    ctaButtonClickUrl="/app/planbuilder/plans"
    ctaButtonText="Upgrade plan"
    ctaDetailText="Get access to additional resources and personalized support options by upgrading your plan."
    ctaHeaderImage={UPGRADE_TO_GET_BETTER_SUPPORT_CTA_HEADER}
    ctaHeaderImageAlt="Support Chatting with Customer"
    ctaTitleText="Upgrade your plan for added support"
    onClickBottomLink={onClickLearnMore}
    onClickCtaButton={onClickUpgrade}
    onKeyDownBottomLink={onKeyDownLearnMore}
    onKeyDownCtaButton={onKeyDownUpgrade}
  />
);

export default UpgradeBlock;
